import React from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import ForgotPassword from 'pages/Auth/ForgotPassword'
import Login from 'pages/Auth/Login'
import ResetPassword from 'pages/Auth/ResetPassword'

import AuthLayout from 'components/Auth/Layout'

import { routes } from 'constants/routes'
import useUser from 'hooks/useUser'

export const AuthRouter: React.FC = () => {
  const { user } = useUser()
  const location = useLocation()
  const { from } = location.state || {
    from: { pathname: '/' },
  }

  return (
    <AuthLayout>
      <Switch>
        <Route path={routes.FORGOT_PASSWORD} component={ForgotPassword} />
        <Route path={routes.RESET_PASSWORD} component={ResetPassword} />
        {user !== undefined ? (
          <Redirect to={from.pathname.length > 1 ? from : routes.HOME} />
        ) : null}
        <Route path={routes.LOGIN} component={Login} />
      </Switch>
    </AuthLayout>
  )
}
